module.exports = [
  {
    path: '/user',
    component: true,
    redirect: '/user/list',
    name: '用户管理',
    children: [
      {
        path: 'list',
        name: '列表',
        component: () => import('@/views/user/list'),
      },
    ]
  },
]


// WEBPACK FOOTER //
// ./src/router/user.js